var map = {
	"./1 Thumbnail, title_ War On Drugs BNN Provinsi Bali Kerjasama dengan STIKes Wira Medika Bali.jpg": 2056,
	"./2 Thumbnail, title_ BNN Nyatakan Perang Lawan Narkoba di Pesawat Lion Group.jpeg": 2503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22404;